import React from 'react';
import FormInput from 'components/Input/FormInput';

interface IProps {
	changeDeactivationSchedule: (value: string) => void;
}

export const DeactivationScheduleInput: React.FC<IProps> = React.memo(({ changeDeactivationSchedule }) => (
	<FormInput
		testId="DeactivationScheduleInput"
		name="deactivationSchedule"
		label="deactivationScheduleLabel"
		placeholder="cronExpressionInputPlaceholder"
		maxLength={255}
		onChange={changeDeactivationSchedule}
	/>
));
